export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqData: FAQItem[] = [
  {
    id: 'faq-01',
    question: '如何判断一个成人内容平台是否合规？',
    answer: '判断平台合规性可从五个维度综合评估：查看平台是否公示运营主体信息和相关资质许可；评估其内容审核机制的完善程度；检查年龄验证系统的有效性；审阅隐私政策的透明度和数据保护标准；验证支付环节的安全性和收费透明度。没有任何单一指标能完全保证平台的安全性，建议进行多维度交叉验证。',
  },
  {
    id: 'faq-02',
    question: '使用VPN访问成人网站是否合法？',
    answer: '使用VPN本身在大多数国家是合法的。但需要综合考量以下因素：您所在地的法律是否禁止访问成人内容；目标网站的使用条款是否允许VPN访问；VPN服务商所在法域的法律要求。关键原则是：VPN是工具，使用工具的合法性取决于使用目的和所在地区的法律规定。建议在使用前了解当地相关法律。',
  },
  {
    id: 'faq-03',
    question: '浏览成人网站时如何有效保护个人隐私？',
    answer: '建议采取多层防护策略：使用独立浏览器进行此类访问；启用隐私模式和追踪防护；使用可靠的VPN服务隐藏真实IP；创建专用电子邮箱和支付方式；定期清除浏览数据；在社交媒体上保持信息隔离。最重要的是培养隐私保护意识，将技术手段与良好习惯相结合。',
  },
  {
    id: 'faq-04',
    question: '收到声称掌握我浏览记录的勒索邮件该怎么办？',
    answer: '首先保持冷静——绝大多数此类威胁都是虚张声势的诈骗。不要支付任何赎金，因为付款并不能保证威胁会停止。不要回复邮件或与勒索者进行任何沟通。保留所有威胁信息作为证据。如果威胁中包含真实的个人信息（如密码），立即更改相关账户的密码并启用双因素认证。可向当地公安机关或网络安全部门举报。',
  },
  {
    id: 'faq-05',
    question: '免费成人网站与付费平台在安全性上有什么区别？',
    answer: '付费平台的运营模式决定了其对用户安全和合规的投入通常更高。合规的付费平台通常具备完善的内容审核、年龄验证和支付安全系统。免费网站则往往依赖广告收入，而广告网络中可能混入恶意广告（Malvertising）。此外，一些免费网站可能通过收集和出售用户数据来盈利。安全性并非绝对取决于是否收费，但合规的付费平台在安全投入上通常更值得信赖。',
  },
  {
    id: 'faq-06',
    question: '如何检查我的设备是否被植入了恶意软件？',
    answer: '可通过以下方式排查：使用经过良好评价的安全软件进行全面扫描；检查系统中是否有异常进程或高CPU使用率（可能被用于挖矿）；查看浏览器中是否出现了未授权的扩展或主页变更；检查网络流量中是否有异常的数据传输。如果怀疑设备已被感染，应立即断开网络连接，使用安全软件进行查杀，必要时寻求专业技术支持。',
  },
  {
    id: 'faq-07',
    question: '在公共场所（如酒店WiFi）浏览成人网站安全吗？',
    answer: '极不安全，强烈不建议。公共WiFi网络通常缺乏足够的安全防护，容易遭受中间人攻击和流量嗅探。即使使用HTTPS连接，DNS查询仍可能暴露您的访问记录。如果必须使用公共网络，务必同时使用可靠的VPN服务，并确保所有连接都经过加密。最安全的做法是在家庭私密网络环境中进行此类访问。',
  },
  {
    id: 'faq-08',
    question: '成人网站的年龄验证会收集哪些个人信息？是否安全？',
    answer: '不同平台的年龄验证方式收集的信息不同。证件验证可能要求提供身份证件照片，隐私风险较高；银行卡验证通过小额交易确认年龄，收集信息相对较少；第三方验证服务通常只向网站返回"是否成年"的结果，不透露具体个人信息，隐私保护程度最高。建议优先选择采用第三方验证服务或银行卡验证的平台，并对要求提供过多个人信息的平台保持警惕。',
  },
  {
    id: 'faq-09',
    question: '本网站的免责声明是什么？',
    answer: '本网站提供的所有信息仅供教育和参考目的，不构成法律、技术或任何其他专业建议。虽然我们努力确保信息的准确性和时效性，但法律法规和技术环境不断变化，我们无法保证所有内容的绝对准确性。用户在做出任何决策前，应自行核实相关信息，并在必要时咨询相关领域的专业人士。本网站不对因使用或依赖本网站信息而产生的任何直接或间接损失承担责任。',
  },
];